import {
    AlertTriangle,
    BookOpen,
    CalendarClock,
    Stethoscope,
    UserRound,
} from 'lucide-react';

import { ENTITY_TINTS } from '@apps/web/lib/entity_palette';

// How chat entities look: icons, colors, pill classes, and the user bubble.
//
// A leaf on purpose. The real chat and mockups of it (the Learn Phoebe fake
// chat) both style from here so the two cannot drift — but a mockup must not
// have to import chat_view.tsx to learn what a caregiver pill looks like, or
// its tests inherit that module's entire graph. Colors come from the shared
// entity palette in `lib/entity_palette.ts`, which the v3 chat also derives
// from.

export type EntityType =
    | 'caregiver'
    | 'client'
    | 'shift'
    | 'callout'
    | 'playbook';

export const ENTITY_CONFIG = {
    shift: {
        icon: CalendarClock,
        label: 'Shift',
        color: ENTITY_TINTS.shift.icon,
    },
    caregiver: {
        icon: Stethoscope,
        label: 'Caregiver',
        color: ENTITY_TINTS.caregiver.icon,
    },
    client: {
        icon: UserRound,
        label: 'Client',
        color: ENTITY_TINTS.client.icon,
    },
    callout: {
        icon: AlertTriangle,
        label: 'Open Shift',
        color: ENTITY_TINTS.callout.icon,
    },
    playbook: {
        icon: BookOpen,
        label: 'Playbook',
        color: ENTITY_TINTS.playbook.icon,
    },
} as const;

export const ENTITY_PILL_CLASSES: Record<EntityType, string> = {
    caregiver: ENTITY_TINTS.caregiver.pill,
    client: ENTITY_TINTS.client.pill,
    shift: ENTITY_TINTS.shift.pill,
    callout: ENTITY_TINTS.callout.pill,
    playbook: ENTITY_TINTS.playbook.pill,
};

export const USER_MESSAGE_BUBBLE_CLASSES =
    'w-fit max-w-[min(100%,42rem)] min-w-0 [overflow-wrap:anywhere] break-words rounded-xl bg-[#ECECEC] px-3.5 py-2 text-sm text-[#2E2E2E]';

// Workbench / training-mode user bubble. Cap width with min() so narrow
// docked chat and the full-page chat share one responsive rule.
export const WORKBENCH_USER_MESSAGE_BUBBLE_CLASSES =
    'w-fit max-w-[min(100%,40rem)] min-w-0 [overflow-wrap:anywhere] break-words rounded-xl border border-[#DBE3E3] bg-[#F0F5F5] px-3 py-2 text-left text-[13px] leading-5 text-[#002429] shadow-[0_1px_0_rgba(0,36,41,0.04)]';

// Next-action choices reuse the workbench bubble and add tap affordances.
export const NEXT_ACTION_CHOICE_BUBBLE_CLASSES = `${WORKBENCH_USER_MESSAGE_BUBBLE_CLASSES} cursor-pointer transition-colors hover:border-[#C5D0D0] hover:bg-[#E7EEEE] disabled:cursor-not-allowed disabled:opacity-50`;
